import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import { createElement } from "@wordpress/element";

/**
 * External dependencies
 */
import { escapeRegExp, first, last } from 'lodash';
import { MenuItem } from '@wordpress/components';
import PropTypes from 'prop-types';
/**
 * Internal dependencies
 */

import { IconCheckChecked, IconCheckUnchecked, IconRadioSelected, IconRadioUnselected } from './icons';

function getHighlightedName(name, search) {
  if (!search) {
    return name;
  }

  var re = new RegExp(escapeRegExp(search), 'ig');
  return name.replace(re, '<strong>$&</strong>');
}

function getBreadcrumbsForDisplay(breadcrumbs) {
  if (breadcrumbs.length === 1) {
    return first(breadcrumbs);
  }

  if (breadcrumbs.length === 2) {
    return first(breadcrumbs) + ' › ' + last(breadcrumbs);
  }

  return first(breadcrumbs) + ' … ' + last(breadcrumbs);
}

var getInteractionIcon = function getInteractionIcon() {
  var isSingle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var isSelected = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (isSingle) {
    return isSelected ? createElement(IconRadioSelected, null) : createElement(IconRadioUnselected, null);
  }

  return isSelected ? createElement(IconCheckChecked, null) : createElement(IconCheckUnchecked, null);
};

var SearchListItem = function SearchListItem(_ref) {
  var countLabel = _ref.countLabel,
      className = _ref.className,
      _ref$depth = _ref.depth,
      depth = _ref$depth === void 0 ? 0 : _ref$depth,
      item = _ref.item,
      isSelected = _ref.isSelected,
      isSingle = _ref.isSingle,
      onSelect = _ref.onSelect,
      _ref$search = _ref.search,
      search = _ref$search === void 0 ? '' : _ref$search,
      _ref$showCount = _ref.showCount,
      showCount = _ref$showCount === void 0 ? false : _ref$showCount,
      props = _objectWithoutProperties(_ref, ["countLabel", "className", "depth", "item", "isSelected", "isSingle", "onSelect", "search", "showCount"]);

  var classes = [className, 'woocommerce-search-list__item'];
  classes.push("depth-".concat(depth));

  if (isSingle) {
    classes.push('is-radio-button');
  }

  var hasBreadcrumbs = item.breadcrumbs && item.breadcrumbs.length;
  return createElement(MenuItem, _extends({
    role: isSingle ? 'menuitemradio' : 'menuitemcheckbox',
    className: classes.join(' '),
    onClick: onSelect(item),
    isSelected: isSelected
  }, props), createElement("span", {
    className: "woocommerce-search-list__item-state"
  }, getInteractionIcon(isSingle, isSelected)), createElement("span", {
    className: "woocommerce-search-list__item-label"
  }, hasBreadcrumbs ? createElement("span", {
    className: "woocommerce-search-list__item-prefix"
  }, getBreadcrumbsForDisplay(item.breadcrumbs)) : null, createElement("span", {
    className: "woocommerce-search-list__item-name",
    dangerouslySetInnerHTML: {
      __html: getHighlightedName(item.name, search)
    }
  })), !!showCount && createElement("span", {
    className: "woocommerce-search-list__item-count"
  }, countLabel || item.count));
};

SearchListItem.propTypes = {
  /**
   * Additional CSS classes.
   */
  className: PropTypes.string,

  /**
   * Label to display if `showCount` is set to true. If undefined, it will use `item.count`.
   */
  countLabel: PropTypes.node,

  /**
   * Depth, non-zero if the list is hierarchical.
   */
  depth: PropTypes.number,

  /**
   * Current item to display.
   */
  item: PropTypes.object,

  /**
   * Whether this item is selected.
   */
  isSelected: PropTypes.bool,

  /**
   * Whether this should only display a single item (controls radio vs checkbox icon).
   */
  isSingle: PropTypes.bool,

  /**
   * Callback for selecting the item.
   */
  onSelect: PropTypes.func,

  /**
   * Search string, used to highlight the substring in the item name.
   */
  search: PropTypes.string,

  /**
   * Toggles the "count" bubble on/off.
   */
  showCount: PropTypes.bool
};
export default SearchListItem;
//# sourceMappingURL=item.js.map